<template>
	<div>
		<!-- 评分标准 -->
		<div class="header">
			<el-popconfirm title="开启专家评分后，评审设置不允许再修改，确定要开启吗？" @confirm="enableScoring" style="margin-right: 20px;">
				<el-button slot="reference" style="background-color: #39afd1;border: #39afd1;" type="primary">开启专家打分</el-button>
			</el-popconfirm>
			<el-button style="background-color: #727cf5;border: #727cf5;" type="primary" @click="addScore(1)" v-if="flow < 5">
				<i class="dripicons-plus mr-1"></i>
				<span>添加评审标准</span>
			</el-button>
		</div>
		<el-table :header-cell-style="tableStyle" border ref="multipleTable" :data="topicList" style="width: 100%">
			<el-table-column prop="name" label="评审标准名称" width="300"></el-table-column>
			<el-table-column prop="note" label="评审标准说明" width="500"></el-table-column>
			<el-table-column prop="score" label="分值"></el-table-column>
			<el-table-column prop="projectUnitName" label="操作">
				<template v-slot:default="scope">
					<el-button type="text" @click="editRowBtn(scope.row, 0)" v-if="flow < 5">修改</el-button>
					<el-button type="text" @click="delRowBtn(scope.row)" v-if="flow < 5">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div style="margin-top: 20px;display: flex;align-items: center;">
			<span>评审标准附件：</span>
			<UploadFile @delBtn="delBtnUpload2" @file-event="changeData('review', $event)" :value="review" btnText="点击上传" />
		</div>

		<el-dialog :title="titleType == 0 ? '修改评审标准' : '添加评审标准'" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="标准名称" prop="name"><el-input v-model="ruleForm.name"></el-input></el-form-item>
				<el-form-item label="标准说明" prop="note"><el-input type="textarea" v-model="ruleForm.note"></el-input></el-form-item>
				<el-form-item label="分值" prop="score"><el-input v-model="ruleForm.score"></el-input></el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addTable">{{ titleType == 0 ? '修改' : '添加' }}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { getEduScoringCriteria, addEduScoringCriteria, delEduScoringCriteria, updateScore, getReviewInfo, updateFile, getEduFile } from '@/api/after/newInterface.js';
import UploadFile from '@/components/UploadFile2.vue';
import { number } from 'echarts/lib/export';
export default {
	components: {
		UploadFile
	},
	props: {
		groupId: {
			type: Number || String,
			default: ''
		}
	},
	data() {
		return {
			tableStyle: {
				textAlign: 'center',
				backgroundColor: '#7e9be2',
				color: '#fff'
			},
			topicList: [],
			dialogVisible: false,
			ruleForm: {
				name: '',
				note: '',
				score: '',
				groupId: ''
			},
			rules: {
				name: [{ required: true, message: '请输入标准名称', trigger: 'blur' }],
				note: [{ required: true, message: '请输入标准说明', trigger: 'blur' }],
				score: [{ required: true, message: '请输入分值', trigger: 'blur' }]
			},
			review: {
				id: '',
				name: ''
			},
			id: null,
			titleType: 0,
			flow: null
		};
	},
	mounted() {
		this.ruleForm.groupId = sessionStorage.getItem('projectId');
		this.id = sessionStorage.getItem('projectId');
		// let upload = JSON.parse(sessionStorage.getItem('reviewUpload'));
		// this.review = upload ? upload : {};
		this.getState();
		this.getTable();
		this.getEduFiles();
	},
	destroyed() {
		sessionStorage.removeItem('reviewUpload');
	},
	methods: {
		getState() {
			getReviewInfo(this.id).then(res => {
				this.flow = res.data.flow;
			});
		},
		getEduFiles() {
			getEduFile(this.ruleForm.groupId).then(res => {
				if (res.data.eduAnnex) {
					this.review = res.data.eduAnnex;
				}
			});
		},
		addScore(type) {
			this.titleType = type;
			this.dialogVisible = true;
		},
		editRowBtn(row, type) {
			this.titleType = type;
			this.ruleForm = Object.assign({}, row);
			this.dialogVisible = true;
		},
		// 文件上传
		changeData(name, data) {
			this.review = data;
			sessionStorage.setItem('reviewUpload', JSON.stringify(data));
			if (data.id) {
				let params = {
					settingId: this.ruleForm.groupId,
					reviewId: data.id
				};
				updateFile(params).then(res => {
					console.log(res, 'res');
				});
			}
		},
		// 删除文件
		delBtnUpload2(e) {
			e.name = '';
			e.id = '';
			sessionStorage.removeItem('reviewUpload');
			let params = {
				settingId: this.ruleForm.groupId,
				reviewId: 0
			};
			updateFile(params).then(res => {
				if (res.code == 200) {
					this.$message.success('操作成功');
				} else {
					this.$message.error(res.data);
				}
			});
		},
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
					this.clearData();
				})
				.catch(_ => {});
		},
		clearData() {
			for (let key in this.ruleForm) {
				this.ruleForm[key] = '';
			}
		},
		//数据
		getTable() {
			getEduScoringCriteria({ pageNumber: 1, pageSize: 999, groupId: this.id, type: 1 }).then(res => {
				if (res.code == 200) {
					this.topicList = res.data.records;
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		// 添加
		addTable() {
			this.$refs.ruleForm.validate(valid => {
				if (valid) {
					if (this.titleType == 0) {
						updateScore(this.ruleForm).then(res => {
							if (res.code == 200) {
								this.$message.success(res.msg);
								this.dialogVisible = false;
								this.getTable();
								this.clearData();
								this.ruleForm.groupId = this.id;
							} else {
								this.$message.error(res.msg);
							}
						});
					} else {
						this.ruleForm.type = 1;
						addEduScoringCriteria(this.ruleForm).then(res => {
							if (res.code == 200) {
								this.$message.success(res.msg);
								this.dialogVisible = false;
								this.getTable();
								this.clearData();
								this.ruleForm.groupId = this.id;
							} else {
								this.$message.error(res.msg);
							}
						});
					}
				}
			});
		},
		//删除
		delRowBtn(row) {
			this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					delEduScoringCriteria({ id: row.id }).then(res => {
						if (res.code == 200) {
							this.$message.success(res.msg);
							this.getTable();
						} else {
							this.$message.error(res.msg);
						}
					});
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},
		// 开启打分
		enableScoring() {
			getReviewInfo(this.ruleForm.groupId).then(res => {
				if (res.code == 200) {
					this.$emit('finishBtn', 7);
				} else {
					this.$message.error(res.msg);
				}
			});
		}
	}
};
</script>

<style scoped lang="scss">
.header {
	display: flex;
	justify-content: flex-end;
	margin-bottom: 20px;
}
</style>
